import React, { useState, useEffect } from 'react';
import { 
  Home,
  Loader,
  CircleDot,
  RotateCw,
  AlignJustify,
  Square,
  RefreshCw,
  CircleEllipsis,
  Activity,
  Sparkles,
  Circle,
  Star,
  ArrowLeftRight,
  Droplet,
  Boxes,
  Clock,
  Eye,
  ChevronLeft,
  ChevronRight,
  LoaderCircle,
  CloudSnow,
  Shapes,
  Octagon,
  Rotate3d,
  AudioWaveform,
  Waves,
  Layers2,
  Copy,
  Move3d,
  Grip,
  Factory,
  Workflow,
  PenLine,
  Flower,
  Ghost
} from 'lucide-react';

const AnimatedMenu = ({ activeCategory="spinner", onCategoryChange, isDarkMode,getLoaderLength,setIsMenuOpen }) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
console.log(activeCategory)
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-5px); }
      }

      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      @keyframes glow {
        0%, 100% { 
          box-shadow: 0 0 5px rgba(139, 92, 246, 0.3),
                     0 0 20px rgba(139, 92, 246, 0.2),
                     0 0 40px rgba(139, 92, 246, 0.1);
        }
        50% { 
          box-shadow: 0 0 10px rgba(139, 92, 246, 0.4),
                     0 0 30px rgba(139, 92, 246, 0.3),
                     0 0 50px rgba(139, 92, 246, 0.2);
        }
      }

      @keyframes slideBackground {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }

      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
      
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }

      .animate-float { animation: float 3s ease-in-out infinite; }
      .animate-pulse { animation: pulse 2s ease-in-out infinite; }
      .animate-spin { animation: spin 20s linear infinite; }
      .animate-glow { animation: glow 2s ease-in-out infinite; }
      .animate-slide { animation: slideBackground 5s ease infinite; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const menuItems = [
    { id: 'spinner', label: 'Spinner', icon: Loader, count: 8 },
    { id: 'dots', label: 'Dots', icon: CircleDot, count: 6 },
    { id: 'progress', label: 'Progress', icon: RotateCw, count: 5 },
    { id: 'bars', label: 'Bars', icon: AlignJustify, count: 4 },
    { id: 'shapes', label: 'Shapes', icon: Square, count: 3 },
    { id: 'flipping', label: 'Flipping', icon: RefreshCw, count: 3 },
    { id: 'colorful', label: 'ColorFul', icon: CircleEllipsis, count: 3 },
    { id: 'pulse', label: 'Pulse', icon: Activity, count: 3 },
    { id: 'hypnotic', label: 'Hypnotic', icon: Sparkles, count: 3 },
    { id: 'blob', label: 'Blob', icon: Circle, count: 3 },
    { id: 'classic', label: 'Classic', icon: Star, count: 3 },
    { id: 'wobbling', label: 'Wobbling', icon: ArrowLeftRight, count: 2 },
    { id: 'filling', label: 'Filling', icon: Droplet, count: 2 },
    { id: 'rolling', label: 'Rolling', icon: RotateCw, count: 2 },
    { id: 'arcade', label: 'Arcade', icon: Boxes, count: 2 },
    { id: 'time', label: 'Time', icon: Clock, count: 2 },
    { id: 'eyes', label: 'Eyes', icon: Eye, count: 2 },
    { id: 'Special Loader', label: 'Special Loader', icon: LoaderCircle, count: 2 },
    { id: 'Cloud', label: 'Cloud', icon: CloudSnow, count: 2 },
    { id: 'Polygons', label: 'Polygons', icon: Octagon, count: 2 },
    { id: '3D', label: '3D', icon: Rotate3d, count: 2 },

    { id: 'Zig-Zag', label: 'Zig-Zag', icon: AudioWaveform, count: 2 },

    { id: 'Wavy', label: 'Wavy', icon: Waves, count: 2 },
    { id: 'Cut', label: 'Cut', icon: Layers2, count: 2 },
    { id: 'Clones', label: 'Clones', icon: Copy, count: 2 },

    { id: 'Arrow', label: 'Arrow', icon: Move3d, count: 2 },
    { id: 'Maze', label: 'Maze', icon: Grip, count: 2 },
    { id: 'Factory', label: 'Factory', icon: Factory, count: 2 },
    { id: 'Continuous', label: 'Continuous', icon: Workflow, count: 2 },
    { id: 'Ninja Stars', label: 'Ninja Stars', icon: Sparkles, count: 2 },

    { id: 'Line', label: 'Line', icon: PenLine, count: 2 },
    { id: 'Nature', label: 'Nature', icon: Flower, count: 2 },
    { id: 'Hungry', label: 'Hungry', icon: Ghost, count: 2 },








    
  ];

  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300; // Adjust scroll amount as needed
      const currentScroll = scrollRef.current.scrollLeft;
      scrollRef.current.scrollTo({
        left: direction === 'left' ? currentScroll - scrollAmount : currentScroll + scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleScroll = (e) => {
    const element = e.target;
    setShowLeftArrow(element.scrollLeft > 0);
    setShowRightArrow(
      element.scrollLeft < element.scrollWidth - element.clientWidth - 10
    );
  };

  return (
    <div className={`
      p-3 rounded-xl
      ${isDarkMode ? 'bg-gray-600' : 'bg-white'}
      shadow-lg
      relative
      w-100 h-full
    `}>
      {/* Background gradient animation */}
      <div className={`
        absolute inset-0 opacity-50 animate-slide
        bg-gradient-to-b ${isDarkMode
          ? 'from-purple-900/20 via-blue-900/20 to-purple-900/20'
          : 'from-purple-100 via-blue-100 to-purple-100'}
      `} />
    
      {/* Sidebar menu container */}
      <div 
        ref={scrollRef}
        className="custom-scrollbar flex flex-col space-y-3 relative h-full "
        
        onScroll={handleScroll}
      >
        {menuItems.map((item, index) => (
          <button
            key={item.id}
            onClick={() => onCategoryChange(item.id)}
            className={`
              relative
              group
              px-4 py-3 rounded-lg flex items-center
              transition-all duration-300
              ${activeCategory === item.id
                ? isDarkMode
                  ? 'bg-purple-500/20'
                  : 'bg-purple-50'
                : 'hover:bg-gray-100/50'}
            `}
            style={{
              animation: `float ${3 + index * 0.2}s ease-in-out infinite`,
              animationDelay: `${index * 0.1}s`
            }}
          >
            {/* Animated border for active item */}
            {activeCategory === item.id && (
              <div className={`
                absolute inset-0 rounded-lg
                ${isDarkMode ? 'bg-purple-500/20' : 'bg-purple-200/50'}
                animate-pulse
              `} />
            )}
    
            {/* Icon */}
            <div className="relative z-10 flex items-center">
              <div className={`
                p-2 rounded-full
                transition-transform duration-300
                group-hover:scale-110
                ${activeCategory === item.id ? 'animate-float' : ''}
              `}>
                <item.icon
                  size={24}
                  className={`
                    ${activeCategory === item.id
                      ? isDarkMode
                        ? 'text-purple-400'
                        : 'text-purple-600'
                      : isDarkMode
                        ? 'text-gray-400'
                        : 'text-gray-500'}
                    transition-colors duration-300
                    group-hover:text-purple-500
                    ${item.id === 'spinner' ? 'group-hover:animate-spin' : ''}
                  `}
                />
              </div>
    
              {/* Label */}
              <span className={`
                ml-3 text-sm font-medium
                transition-colors duration-300
                ${activeCategory === item.id
                  ? isDarkMode
                    ? 'text-purple-400'
                    : 'text-purple-600'
                  : isDarkMode
                    ? 'text-gray-300'
                    : 'text-gray-600'}
              `}>
                {item.label}
              </span>
            </div>
    
            {/* Badge */}
            <div className={`
              ml-auto px-2 py-0.5 rounded-full
              text-xs font-bold
              transition-all duration-300
              ${activeCategory === item.id
                ? isDarkMode
                  ? 'bg-purple-500 text-white'
                  : 'bg-purple-500 text-white'
                : isDarkMode
                  ? 'bg-gray-700 text-gray-300'
                  : 'bg-gray-200 text-gray-600'}
              animate-pulse
            `}>
              {getLoaderLength(item.label)}
            </div>
    
            {/* Hover glow effect */}
            <div className={`
              absolute inset-0 rounded-lg
              transition-opacity duration-300
              opacity-0 group-hover:opacity-100
              ${isDarkMode ? 'animate-glow' : ''}
            `} />
          </button>
        ))}
      </div>
    </div>
    
  );
};

export default AnimatedMenu;